import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Show, SignUp } from "@clerk/react";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Shell from "@/components/Shell";
import Overview from "@/pages/Overview";
import Agents from "@/pages/Agents";
import Tasks from "@/pages/Tasks";
import QA from "@/pages/QA";
import Releases from "@/pages/Releases";
import Approvals from "@/pages/Approvals";
import Audit from "@/pages/Audit";
import Connectors from "@/pages/Connectors";
import Console from "@/pages/Console";
import Consent, { SignInPage } from "@/pages/Consent";
import OpsOverview from "@/pages/ops/OpsOverview";
import OwnerWorkspace from "@/pages/ops/OwnerWorkspace";
import DeptBoard from "@/pages/ops/DeptBoard";

const Protected = () => {
  const loc = useLocation();
  return (
    <>
      <Show when="signed-in"><Shell /></Show>
      <Show when="signed-out"><Navigate to={`/sign-in?redirect_url=${encodeURIComponent(loc.pathname)}`} replace /></Show>
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/sign-in/*" element={<SignInPage />} />
          <Route path="/sign-up/*" element={<div className="grid min-h-screen place-items-center p-4"><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></div>} />
          <Route path="/oauth/consent" element={<Consent />} />
          <Route element={<Protected />}>
            <Route path="/" element={<Overview />} />
            <Route path="/agents" element={<Agents />} />
            <Route path="/tasks" element={<Tasks />} />
            <Route path="/qa" element={<QA />} />
            <Route path="/releases" element={<Releases />} />
            <Route path="/approvals" element={<Approvals />} />
            <Route path="/audit" element={<Audit />} />
            <Route path="/connectors" element={<Connectors />} />
            <Route path="/console" element={<Console />} />
            <Route path="/ops" element={<OpsOverview />} />
            <Route path="/ops/owner" element={<OwnerWorkspace />} />
            <Route path="/ops/:dept" element={<DeptBoard />} />
          </Route>
        </Routes>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
